export const etiquetas = [ 
    'node',
    'express',
    'sql',
    'nosql',
    'mongodb',
    'postgresql',
    'mariadb',
    'mysql',
    'authentication',
    'jwt',
    'firebase',
    'database',
    'java',
    'python',
    'javascript',
      'css',
    'tailwind',
    'bootstrap',
    'html',
    'react',
    'react-query',
    'angular',
    'vue',
    'redux',
    'php',
    'net',
    'c',
    'c#',
    'laravel',
    'wordpress',
    'vscode',
    'linux',
    'windows',
    'ios',
    'frontend',
    'backend',

]